import { RootState } from 'store/store';
import { createSelector } from '@reduxjs/toolkit';

export const organizersStoreSelector = (state: RootState) => state.organizers;
export const selectOrganizersOptions = createSelector(organizersStoreSelector, (state) => state);
export const selectOrganizerById = (id: number) =>
  createSelector(organizersStoreSelector, (state) => state.organizers.find((item) => item.id === id));
export const selectActiveOrganizerPlans = (tournamentId: number) =>
  createSelector([organizersStoreSelector], (state) => state.plans.byOwnerId[tournamentId]);

export const selectPlansList = createSelector([organizersStoreSelector], (state) => state.plans.list);

export const selectOrganizersPagination = createSelector(
  organizersStoreSelector,
  (state) => ({ hasNextPage: state.hasNextPage, currentPage: state.currentPage, perPage: state.perPage }),
);

export const selectOrganizersFilters = createSelector(
  organizersStoreSelector,
  (state) => ({
    filter: state.filter,
    filterByNumber: state.filterByNumber,
    sortByDate: state.sortByDate,
    filterBySportType: state.filterBySportType,
  }),
);
